import API from "serviceshift-ui/api-client";

import { helpers } from "@vuelidate/validators";
import { getAPIURL } from "../lib/helpers.js";

// Set api-client base url
API.init({
  API_BASE_URL: getAPIURL()
});

export const createUniqueEmailValidator = (initialValue = null) => {
  return helpers.withAsync(
    helpers.withMessage("Email address already in use", (value) => {
      if (!value || value.trim() === "") return true;
      if (initialValue && value === initialValue) return true;

      return API.user
        .validateEmail({ email: value })
        .then(() => true)
        .catch(() => false);
    })
  );
};

export const uniqueEmail = createUniqueEmailValidator();

export const createUniqueAccountEmailValidator = (emails) => {
  return helpers.withMessage("Emails must be unique.", (value) => {
    if (!value || value.trim() === "") return true;

    return emails.filter((email) => email.email_address === value).length < 2;
  });
};
